import MobileChecker from './mobile-checker';

class BaseHelpers {
    static html = document.documentElement;
    static header = document.querySelector('.header');
    static firstScreen = document.querySelector('[data-observ]');

    /**
     * Проверка браузера на поддержку .webp изображений
     * (i) необходимо для корректного отображения webp из css
     * */
    static checkWebpSupport() {
        /** Проверка поддержки webp */
        const testWebp = (callback) => {
            const webP = new Image();

            webP.onload = webP.onerror = () => callback(webP.height === 2);
            webP.src =
                'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        };

        /** Добавление класса _webp или _no-webp для HTML */
        testWebp((support) => {
            const className = support ? 'webp' : 'no-webp';
            BaseHelpers.html.classList.add(className);
        });
    }

    /**
     * Добавление класса touch для HTML если браузер мобильный
     * */
    static addTouchClass() {
        if (MobileChecker.isAny) {
            BaseHelpers.html.classList.add('touch');
        }
    }

    /**
     * Добавление loaded для HTML после полной загрузки страницы
     * */
    static addLoadedClass() {
        window.addEventListener('load', () => {
            setTimeout(() => {
                BaseHelpers.html.classList.add('loaded');
            }, 0);
        });
    }

    /** Получение хеша в адресе сайта */
    static get getHash() {
        return location.hash?.replace('#', '');
    }

    /** Указание хеша в адресе сайта */
    static setHash(hash) {
        hash = hash ? `#${hash}` : location.href.split('#')[0];
        history.pushState('', '', hash);
    }

    static isMobileScreen() {
        const screenWidth = window.innerWidth;

        return screenWidth <= 768 ? true : false;
    }

    /**
     * Контент блоку data-placeholder має змінювати parent-а
     * в залежності від девайсу data-placeholder="desktop" || data-placeholder="mobile".
     */
    static placeholderReplacer() {
        const isMobile = BaseHelpers.isMobileScreen();
        const dataPlaceholder = document.querySelectorAll('[data-placeholder]');

        if (dataPlaceholder) {
            const placeholderDesktop = document.querySelectorAll('[data-placeholder="desktop"]');
            const placeholderMobile = document.querySelectorAll('[data-placeholder="mobile"]');

            if (!isMobile) {
                placeholderMobile.forEach((el, i) => {
                    placeholderDesktop[i].append(el);
                });
            }
        }
    }

    /**
     * Header navigation should hide on scrolldown
     * and turn back on scrollup
     */
    static headerScrollUpTrigger() {
        const headerElement = document.querySelector('.header');
        const mobileCheckbox = document.getElementById('mobile-menu');

        const defaultHeaderHeight = `-${headerElement.offsetHeight}px`;
        let lastScrollTop = 0;

        window.addEventListener('scroll', function() {
            let currentScroll = window.scrollY || document.documentElement.scrollTop;

            if (currentScroll < lastScrollTop) {
                // Scrolling up
                headerElement.style.top = '0px';
            } else {
                // Scrolling down
                headerElement.style.top = defaultHeaderHeight;

                // Uncheck mobileCheckbox on scroll for mobile
                mobileCheckbox.checked = mobileCheckbox.checked === true ? false : null;
            }

            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
        }, false);
    }

    /**
     * Pages has signal tape styled titles - .title-tape, .signal-tape,
     * this function provides filling the tape with title from data-tape-text
     */
    static titleTapeProcessor() {
        const tapes = document.querySelectorAll('.signal-tape');

        function tapeFiller(text, tape) {
            const spanOpen = '<span>';
            const spanClose = '</span>';
            const titleWrapped = spanOpen + text + spanClose;
            const titleRepeatTimes = 30;
            let titleHtml = '';

            for (let i = 0; i < titleRepeatTimes; i++) {
                titleHtml += titleWrapped;
            }

            tape.insertAdjacentHTML('beforeend', titleHtml);
        }

        if (tapes.length) {
            tapes.forEach(el => {
                const tapeText = el.dataset.tapeText;

                if (Boolean(tapeText)) {
                    tapeFiller(tapeText, el);
                }
            });
        }
    }
}

export default BaseHelpers;